
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/where-donations-go",
      function () {
        return require("private-next-pages/where-donations-go.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/where-donations-go"])
      });
    }
  